// removed by extract-text-webpack-plugin
module.exports = {"container":"a9_g","heading1":"a9_ba","heading2":"a9_bb"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventTicketsPage/styles.module.css
// module id = 314
// module chunks = 27